import "../../../../stylesheets/video-js.min.css";
import "../../../../stylesheets/videojs-style-overrides.css";

import { Box, Theme } from "@outschool/backpack";
import {
  MarkLessonCompleteMutation,
  MarkLessonCompleteMutationVariables,
} from "@outschool/gql-frontend-generated";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { LearnerRoutes } from "@outschool/routes";
import { guessBrowserTimeZone } from "@outschool/time";
import { gql, useMutation } from "@outschool/ui-apollo";
import {
  ClassRecordingContent,
  useMuxClassRecordingQuery,
} from "@outschool/ui-components-classroom";
import { TrackingPage } from "@outschool/ui-legacy-component-library";
import { useNavigation } from "@outschool/ui-utils";
import React from "react";
import { useAnalytics } from "use-analytics";

import useAnalyticsPage, {
  PageType,
} from "../../lib/analytics/useAnalyticsPage";
import { useCurrentLearner } from "../../providers/CurrentLearnerProvider";
import { useLearnerClassroomContext } from "../../providers/LearnerClassroomProvider";

export default function RecordingPage({
  recordingUid,
}: {
  recordingUid: string;
}) {
  const navigate = useNavigation();
  const { track } = useAnalytics();
  const { sectionUid, hasLessons } = useLearnerClassroomContext();
  const currentLearner = useCurrentLearner();
  const userTimeZone = currentLearner?.timeZone || guessBrowserTimeZone();

  useAnalyticsPage({
    pageName: PageType.Recording,
    pageParams: { sectionUid, recordingUid },
  });

  const [markLessonComplete] = useMutation<
    MarkLessonCompleteMutation,
    MarkLessonCompleteMutationVariables
  >(MarkLessonCompleteForRecording, {
    variables: { recordingUid },
  });

  const {
    loading,
    error,
    isExpired,
    activity,
    section,
    startTime,
    endTime,
    meeting,
    learnersForParentInSection,
  } = useMuxClassRecordingQuery({
    sectionUid,
    recordingUid,
  });

  const handlePlayClick = () => {
    if (hasLessons) {
      markLessonComplete();
    }
  };

  return (
    <TrackingPage
      name="learnerClassRecording"
      uniqueId={recordingUid}
      activity={activity}
      section={section}
    >
      {(setImpressionNode: (node: HTMLElement) => void) => (
        <Box
          ref={(node: HTMLElement) => setImpressionNode(node)}
          sx={(theme: Theme) => ({
            margin: "2rem 0 6rem 0",
            [theme.breakpoints.down("md")]: {
              margin: "1rem",
            },
          })}
        >
          <ClassRecordingContent
            recordingUid={recordingUid}
            loading={loading}
            error={error}
            isExpired={isExpired}
            sectionUid={sectionUid}
            userTimeZone={userTimeZone}
            isLearner={true}
            section={section}
            activity={activity}
            startTime={startTime}
            endTime={endTime}
            canManage={false}
            meeting={meeting}
            learnersForParentInSection={learnersForParentInSection}
            handlePlayClick={handlePlayClick}
            handleBackClick={() =>
              navigate(LearnerRoutes.classroomPath(sectionUid))
            }
            track={track}
          />
        </Box>
      )}
    </TrackingPage>
  );
}

const MarkLessonCompleteForRecording = gql`
  mutation MarkLessonComplete($recordingUid: ID!) {
    markLessonCompleteFromClassRecording(classRecordingUid: $recordingUid)
  }
`;
